import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export var MaskboxStatistic_OrderBy;
(function (MaskboxStatistic_OrderBy) {
    MaskboxStatistic_OrderBy["Id"] = "id";
    MaskboxStatistic_OrderBy["Total"] = "total";
})(MaskboxStatistic_OrderBy || (MaskboxStatistic_OrderBy = {}));
export var Maskbox_OrderBy;
(function (Maskbox_OrderBy) {
    Maskbox_OrderBy["BlockNumber"] = "blockNumber";
    Maskbox_OrderBy["BoxId"] = "box_id";
    Maskbox_OrderBy["Canceled"] = "canceled";
    Maskbox_OrderBy["ChainId"] = "chain_id";
    Maskbox_OrderBy["Claimed"] = "claimed";
    Maskbox_OrderBy["CreateTime"] = "create_time";
    Maskbox_OrderBy["Creator"] = "creator";
    Maskbox_OrderBy["DrawedByCustomer"] = "drawed_by_customer";
    Maskbox_OrderBy["EndTime"] = "end_time";
    Maskbox_OrderBy["Id"] = "id";
    Maskbox_OrderBy["Name"] = "name";
    Maskbox_OrderBy["NftAddress"] = "nft_address";
    Maskbox_OrderBy["NftContract"] = "nft_contract";
    Maskbox_OrderBy["SellAll"] = "sell_all";
    Maskbox_OrderBy["SoldNftList"] = "sold_nft_list";
    Maskbox_OrderBy["StartTime"] = "start_time";
    Maskbox_OrderBy["TxHash"] = "tx_hash";
})(Maskbox_OrderBy || (Maskbox_OrderBy = {}));
export var NftContract_OrderBy;
(function (NftContract_OrderBy) {
    NftContract_OrderBy["Address"] = "address";
    NftContract_OrderBy["ChainId"] = "chain_id";
    NftContract_OrderBy["Id"] = "id";
    NftContract_OrderBy["Name"] = "name";
})(NftContract_OrderBy || (NftContract_OrderBy = {}));
export var OrderDirection;
(function (OrderDirection) {
    OrderDirection["Asc"] = "asc";
    OrderDirection["Desc"] = "desc";
})(OrderDirection || (OrderDirection = {}));
export var User_OrderBy;
(function (User_OrderBy) {
    User_OrderBy["Id"] = "id";
    User_OrderBy["NftContracts"] = "nft_contracts";
})(User_OrderBy || (User_OrderBy = {}));
export var _SubgraphErrorPolicy_;
(function (_SubgraphErrorPolicy_) {
    /** Data will be returned even if the subgraph has indexing errors */
    _SubgraphErrorPolicy_["Allow"] = "allow";
    /** If the subgraph has indexing errors, data will be omitted. The default. */
    _SubgraphErrorPolicy_["Deny"] = "deny";
})(_SubgraphErrorPolicy_ || (_SubgraphErrorPolicy_ = {}));
export const MaskBoxDocument = gql `
  query MaskBox($id: ID!) {
    maskbox(id: $id) {
      id
      box_id
      chain_id
      name
      creator
      nft_address
      start_time
      end_time
      sell_all
      nft_contract {
        address
        name
      }
    }
  }
`;
/**
 * __useMaskBoxQuery__
 *
 * To run a query within a React component, call `useMaskBoxQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaskBoxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaskBoxQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMaskBoxQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(MaskBoxDocument, options);
}
export function useMaskBoxLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(MaskBoxDocument, options);
}
export const MaskBoxesDocument = gql `
  query MaskBoxes($first: Int! = 10, $skip: Int! = 0, $ignores: [ID!]!, $from: Int! = 10) {
    maskboxes(
      orderBy: create_time
      orderDirection: desc
      first: $first
      skip: $skip
      where: { canceled: false, box_id_gt: $from, id_not_in: $ignores }
    ) {
      id
      box_id
      chain_id
      name
      creator
      nft_address
      start_time
      end_time
      sell_all
      nft_contract {
        address
        name
      }
    }
  }
`;
/**
 * __useMaskBoxesQuery__
 *
 * To run a query within a React component, call `useMaskBoxesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaskBoxesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaskBoxesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      ignores: // value for 'ignores'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useMaskBoxesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(MaskBoxesDocument, options);
}
export function useMaskBoxesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(MaskBoxesDocument, options);
}
export const MaskBoxesOfDocument = gql `
  query MaskBoxesOf($first: Int! = 10, $skip: Int! = 0, $account: Bytes!) {
    maskboxes(
      orderBy: create_time
      orderDirection: desc
      first: $first
      skip: $skip
      where: { creator: $account }
    ) {
      id
      box_id
      chain_id
      name
      creator
      nft_address
      start_time
      end_time
      sell_all
      canceled
      claimed
      nft_contract {
        address
        name
      }
      sold_nft_list
      drawed_by_customer
    }
  }
`;
/**
 * __useMaskBoxesOfQuery__
 *
 * To run a query within a React component, call `useMaskBoxesOfQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaskBoxesOfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaskBoxesOfQuery({
 *   variables: {
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      account: // value for 'account'
 *   },
 * });
 */
export function useMaskBoxesOfQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(MaskBoxesOfDocument, options);
}
export function useMaskBoxesOfLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(MaskBoxesOfDocument, options);
}
export const MaskBoxClaimedStatusDocument = gql `
  query MaskBoxClaimedStatus($id: ID!) {
    maskbox(id: $id) {
      id
      claimed
    }
  }
`;
/**
 * __useMaskBoxClaimedStatusQuery__
 *
 * To run a query within a React component, call `useMaskBoxClaimedStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaskBoxClaimedStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaskBoxClaimedStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMaskBoxClaimedStatusQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(MaskBoxClaimedStatusDocument, options);
}
export function useMaskBoxClaimedStatusLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(MaskBoxClaimedStatusDocument, options);
}
export const CheckMaskBoxesOfDocument = gql `
  query CheckMaskBoxesOf($account: Bytes!) {
    maskboxes(first: 1) {
      id
    }
  }
`;
/**
 * __useCheckMaskBoxesOfQuery__
 *
 * To run a query within a React component, call `useCheckMaskBoxesOfQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckMaskBoxesOfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckMaskBoxesOfQuery({
 *   variables: {
 *      account: // value for 'account'
 *   },
 * });
 */
export function useCheckMaskBoxesOfQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(CheckMaskBoxesOfDocument, options);
}
export function useCheckMaskBoxesOfLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(CheckMaskBoxesOfDocument, options);
}
export const SoldNftListDocument = gql `
  query SoldNFTList($id: ID!) {
    maskbox(id: $id) {
      id
      drawed_by_customer
    }
  }
`;
/**
 * __useSoldNftListQuery__
 *
 * To run a query within a React component, call `useSoldNftListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoldNftListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoldNftListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoldNftListQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(SoldNftListDocument, options);
}
export function useSoldNftListLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(SoldNftListDocument, options);
}
export const NftContractsOfDocument = gql `
  query NFTContractsOf($addr: ID!) {
    user(id: $addr) {
      nft_contracts {
        id
        address
      }
    }
  }
`;
/**
 * __useNftContractsOfQuery__
 *
 * To run a query within a React component, call `useNftContractsOfQuery` and pass it any options that fit your needs.
 * When your component renders, `useNftContractsOfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNftContractsOfQuery({
 *   variables: {
 *      addr: // value for 'addr'
 *   },
 * });
 */
export function useNftContractsOfQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(NftContractsOfDocument, options);
}
export function useNftContractsOfLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(NftContractsOfDocument, options);
}
export const StatisticDocument = gql `
  query Statistic($id: ID!) {
    maskboxStatistic(id: $id) {
      id
      total
    }
  }
`;
/**
 * __useStatisticQuery__
 *
 * To run a query within a React component, call `useStatisticQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatisticQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatisticQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStatisticQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(StatisticDocument, options);
}
export function useStatisticLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(StatisticDocument, options);
}
